import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subject, takeUntil} from "rxjs";
import {AuthenticationService} from "../../auth/services/authentication.service";
import {MatPaginator} from "@angular/material/paginator";
import {User} from "../../auth/models/User";
import {MatTableDataSource} from "@angular/material/table";
import {AdminService} from "../services/admin.service";
import {MatDialog} from "@angular/material/dialog";
import Swal from 'sweetalert2';
import {UserDialogComponent} from "./user-dialog/user-dialog.component";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit, AfterViewInit, OnDestroy {
  users = new MatTableDataSource<any>();
  currentUser!: User;
  displayedColumns: string[] = ['fullName', 'email', 'role', 'remove'];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  totalItems = 0;
  pageSize = 10;
  private destroy$ = new Subject<void>();

  constructor(
    private adminService: AdminService,
    private authenticationService: AuthenticationService,
    public dialog: MatDialog,
    private translate: TranslateService
  ) {
    this.authenticationService.currentUser.pipe(takeUntil(this.destroy$)).subscribe(x => {
      this.currentUser = x!;
    });
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.loadData();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadData() {
    if (this.currentUser) {
      this.adminService.getAllUsers().subscribe(result => {
        if (result && result.content) {
          this.users = new MatTableDataSource(result.content);
          this.totalItems = result.totalElements;
          this.paginator.length = this.totalItems;
        }
      }, (error: any) => {
        console.error(error);
      });
    }
  }

  openCreateUserDialog(): void {
    const dialogRef = this.dialog.open(UserDialogComponent, {
      width: '400px',
      height: '500px',
      data: {user: null}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadData();
      }
    });
  }

  openEditUserDialog(user: any): void {
    const dialogRef = this.dialog.open(UserDialogComponent, {
      width: '400px',
      height: '500px',
      data: {user}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadData();
      }
    });
  }

  deleteUser(userId: string): void {
    this.translate.get([
      'Are you sure?',
      'You won\'t be able to revert this!',
      'Yes, delete it!',
      'No, cancel!',
      'Deleted',
      'The user has been deleted.',
      'Error',
      'An error occurred while deleting the user.'
    ]).subscribe(translations => {
      Swal.fire({
        title: translations['Are you sure?'],
        text: translations['You won\'t be able to revert this!'],
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: translations['Yes, delete it!'],
        cancelButtonText: translations['No, cancel!']
      }).then((result: any) => {
        if (result.isConfirmed) {
          this.adminService.deleteUser(userId).subscribe(() => {
            Swal.fire(translations['Deleted'], translations['The user has been deleted.'], 'success');
            this.loadData();
          }, (error) => {
            Swal.fire(translations['Error'], translations['An error occurred while deleting the user.'], 'error');
          });
        }
      });
    });
  }

}
